import { render, staticRenderFns } from "./KM218MGD.vue?vue&type=template&id=6ec87e20&scoped=true&"
import script from "./KM218MGD.vue?vue&type=script&lang=js&"
export * from "./KM218MGD.vue?vue&type=script&lang=js&"
import style0 from "./KM218MGD.vue?vue&type=style&index=0&id=6ec87e20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec87e20",
  null
  
)

export default component.exports